<template>
  <div :class="`drag-dom ${isInit ? 'all' : ''}`">
    <div style="width: 100%; height: 100%; overflow: hidden" :id="id"></div>
  </div>
</template>

<script>
import Player from "xgplayer";
import { defineComponent, onMounted, ref, reactive, watch } from "vue";

export default defineComponent({
  name: "Comment-Items",
  props: {
    id: String,
    datas: Object,
    poster: String,
    canPlay: Boolean,
    height: String,
    autoplay: {
      type: Boolean,
      default: true,
    },
    canKaoshi: Boolean,
    init: {
      type: Boolean,
      default: false,
    },
    isfullscreen: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    let videoData = ref({});
    let player = reactive(null);
    let vHeight = ref("211px");

    // 初始化西瓜视频
    const initPlayer = () => {
      if (player) {
        player.poster = props.poster || videoData.value.banner;
        player.removeAllProgressDot();
        player.start(videoData.value.content);
        player.currentTime = videoData.value.userViewTime;
      } else {
        player = new Player({
          width: "100%",
          height: `${vHeight.value}`,
          id: props.id,
          url: videoData.value.content,
          poster: props.poster || videoData.value.banner,
          currentTime: videoData.value.userViewTime,
          lastPlayTime: videoData.value.userViewTime,
          lastPlayTimeHideDelay: 0,
          playsinline: true,
          autoplay: props.autoplay,
          closeInactive: false,
          // disableProgress: true, //禁止拖动
          customFullscreen: true, // 自定义插件属性
          // cssFullscreen: true,
          fullscreen: false,
          allowSeekPlayed: !canTuo.value,
        });

        player.on("play", () => {
          emit("play", player);
        });
        player.on("timeupdate", () => {
          emit("timeupdate", player);
        });
        player.on("pause", () => {
          emit("pause", player);
        });
        player.on("ended", () => {
          emit("ended", player);
        });
        player.on("requestCustomFullscreen", () => {
          if (props.isfullscreen) {
            console.log("退出自定义全屏");
            emit("showNavarBar", { ele: player, flag: false });
          } else {
            console.log("进入自定义全屏");
            emit("showNavarBar", { ele: player, flag: true });
          }
          document.body.style.overflow = "hidden";
        });
        player.on("exitCustomFullscreen", () => {
          if (props.isfullscreen) {
            console.log("退出自定义全屏");
            emit("showNavarBar", { ele: player, flag: false });
          } else {
            console.log("进入自定义全屏");
            emit("showNavarBar", { ele: player, flag: true });
          }
          document.body.style.overflow = "auto";
        });
      }
    };
    watch(
      () => props.datas.content,
      (newValue) => {
        if (newValue) {
          videoData.value = props.datas;
          initPlayer();
        }
      },
      {
        deep: true,
      }
    );
    watch(
      () => props.canPlay,
      (newValue) => {
        if (newValue) {
          if (player) {
            player.play();
          } else {
            initPlayer();
          }
        } else {
          player.pause();
        }
      },
      {
        deep: true,
      }
    );
    let canTuo = ref(false);
    watch(
      () => props.canKaoshi,
      (newValue) => {
        canTuo.value = newValue;
      },
      {
        deep: true,
      }
    );
    const isInit = ref(false);
    onMounted(() => {
      vHeight.value = props.height;
      videoData.value = props.datas;
      isInit.value = props.init;
      if (props.init) {
        canTuo.value = true;
        initPlayer();
      }
    });
    return {
      isInit,
      videoData,
    };
  },
});
</script>
<style lang="less" scoped>
/deep/ .xgplayer-fullscreen {
  display: none;
}
.drag-dom {
  height: 100%;

  #xgPlayer {
    border-radius: 8px;
    z-index: 20;
    background: #000;
    &.xgplayer-rotate-fullscreen {
      border-radius: 0;
      position: fixed;
      z-index: 999;
      &.xgplayer-ended {
        /deep/ .xgplayer-controls {
          display: flex;
          z-index: 110;
          .xgplayer-play {
            display: none;
          }
          .xgplayer-progress {
            display: none;
          }
        }
      }
    }
  }
  &.all {
    border-radius: 0;
    #xgPlayer {
      border-radius: 0;
    }
  }
  /deep/ .xgplayer-controls {
    transform: translateZ(100px);
  }
  /deep/ .xgplayer-start {
    transform: translateZ(100px);
  }
  /deep/ .xgplayer-replay {
    transform: translateZ(100px);
  }
  /deep/.xgplayer-skin-default.xgplayer-inactive .xgplayer-miniplayer-drag {
    display: block;
  }
}
</style>
